import React from "react";
import styles from "./deleteConfirmModal.module.css";

export default function DeleteConfirmModal({
  onDeleteMythConfirm,
  onDeleteMythCancel,
  currMyth,
}) {
  return (
    <div className={styles.deleteConfirmModal}>
      <div className={styles.content}>
        <h3>{currMyth.title}</h3>
        <p>
          <strong>Are you sure you want to delete this myth?</strong>
        </p>
        <p>
          This cannot be undone. All images, auto and information will be
          deleted.
        </p>
        <div className={styles.buttonSection}>
          <button onClick={onDeleteMythConfirm} className="funButton cancel">
            Delete Myth
          </button>
          <button onClick={onDeleteMythCancel} className="funButton">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
